<template>
  <div
    class="block-masonry-images"
    :class="{ 'is-on-grid': isOnGrid }"
  >
    <div class="block-masonry-images__inner">
      <masonry-wall
        :items="images"
        :gap="10"
        :min-columns="minColumns"
      >
        <template #default="{ item }">
          <div
            class="block-masonry-images__item"
            :style="`--aspect-ratio: ${item.image.width} / ${item.image.height}`"
            @click="openOverlay(item)"
            @keypress="openOverlay(item)"
          >
            <AtomImage
              class="block-masonry-images__image"
              :class="{ 'is-loaded': item.image.loaded }"
              behaviour="cover"
              :user="item.user"
              :image="{
                src: item.image.src,
                alt: item.image.alt,
              }"
              @on-load="async () => {
                await sleep(500);
                item.image.loaded = true;
              }"
            />
            <ClientOnly>
              <AtomButtonFullscreen
                :class="{ 'is-loaded': item.image.loaded }"
                class="block-masonry-images__button-fullscreen"
                icon-color="var(--c-white)"
              />
            </ClientOnly>
          </div>
        </template>
      </masonry-wall>
    </div>

    <BlockOverlaySlot
      :is-open="isOverlayOpen"
      :is-scrollable="false"
      @on-close="isOverlayOpen = false"
    >
      <div
        class="block-masonry-images__fullscreen"
      >
        <AtomImage
          class="block-masonry-images__image-fullscreen"
          :style="`aspect-ratio: ${activeItem.image.width / activeItem.image.height};`"
          :image="activeItem.image"
          behaviour="contain"
        />
      </div>
    </BlockOverlaySlot>
  </div>
</template>

<script setup>
const props = defineProps({
    /* Layout */
    isOnGrid: {
        type: Boolean,
        default: false,
    },

    /* Content */
    images: {
        type: Array,
        default: () => [],
    },

    /* Colors */
    backgroundColor: {
        type: String,
        default: 'var(--c-primary--light)',
    },
});
const minColumns = computed(() => {
    if (isGreaterThanLargeDesktop.value) return 3;
    if (isGreaterThanTabletPortrait.value) return 2;
    return 1;
});

const {
    backgroundColor,
} = toRefs(props);

/*
    Overlay
*/
const activeItem = ref(null);
const isOverlayOpen = ref(false);

const openOverlay = (item) => {
    activeItem.value = item;
    isOverlayOpen.value = true;
};
</script>

<style lang="scss" scoped>
.block-masonry-images__fullscreen {
    position: relative;
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 100%;
    max-height: 100%;
}

.block-masonry-images__image-fullscreen {
    display: flex;
    width: 100%;
    height: 100%;
    margin-top: auto;

    ::v-deep(.atom-image__background) {
        margin: auto;
    }
}

.block-masonry-images {
    &.is-on-grid{
        @include wrapper-layout;
        @include grid-layout;

        margin-bottom: var(--m-bottom--big);
    }
}

.block-masonry-images__inner {

    .is-on-grid & {
        @include default-content-columns('wide');
    }
}

.block-masonry-images__item {
    position: relative;
    overflow: hidden;
    border-radius: var(--border-radius);
    aspect-ratio: var(--aspect-ratio);
    background: v-bind(backgroundColor);
    cursor: pointer;
}

.block-masonry-images__image {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.6s ease-out;

    &.is-loaded {
        opacity: 1;
    }
}

.block-masonry-images__button-fullscreen {
    @include fluid-simple('right', 10px, 20px);
    @include fluid-simple('top', 10px, 20px);

    position: absolute;
    z-index:10;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.6s ease-out;

    &.is-loaded {
        opacity: 1;
    }
}
</style>
